<template>
  <div
    class="notification"
  >
    <div 
      class="notification-card"
    >
      <div 
        class="__card-content"
      >
        <span
          class="__notification-type"
          v-html="notificationType"
        />
        <span
          class="__notification-date"
        >
          {{
            `${formatDateShort(notification.displayFromDate)} | ${formatDateTime(notification.displayFromDate)} ${timeZoneName(notification.displayFromDate)}`
          }}
        </span>
        <span
          class="__notification-title"
          v-html="notification.headlineTop"
        />
        <p
          :class="!hover ? '__notification-description' : '' "
          v-html="notification.text"
          @click="toggleDescription"
        />
        <a
          class="__notification-link"
          @click.stop.prevent="openHtmlLink(notification.headlineTop, notification.optionalLink)"
        >
          {{ linkPlaceholder }}
        </a>
      </div>

    </div>
  </div>
</template>

<script>
import trackingApi from '~/api/tracking'
import { mapActions, mapGetters } from 'vuex'
import pageStateMixins from 'm-anage.com.vmx-components/src/mixins/pageStateMixins'
import dateMixins from 'm-anage.com.vmx-components/src/mixins/dateMixins'
import appContainerMixins from 'm-anage.com.vmx-components/src/mixins/appContainerMixins'

export default {
  inheritAttrs: false,
  mixins: [pageStateMixins, dateMixins, appContainerMixins],
  props: {
    notification: {
      type: Object,
      default() {
        return {}
      },
    },
    notificationMultiple: {
      type: Boolean,
      default: true,
    },
  },
    data() {
      return {
        hover: false,
      }
    },
  methods: {
     ...mapActions({
      loadConfig: 'config/loadConfig',
    }),
    openHtmlLink(name, url) {
      trackingApi.trackCustomAction(
        'vmx-notification-card',
        name,
        url,
      )
      if(this.isAppContainer) {
        this.openLink(url)
        return
      }
    window.open(url, this.notificationLinkTarget)
    },
    toggleDescription() {
      this.hover = !this.hover
    },
  }, 
  computed: {
     ...mapGetters({
      configForKey: 'config/configForKey',
      isAppContainer: 'instancesState/getIsAppContainer'
    }),
    notificationType(){
      if(this.notification.type === 'Firebase') return 'Onsite'
      if(this.notification.type === 'PushNotification') return 'Virtual'
      else return ''
    },
    notificationLinkTarget() {
      const config = this.configForKey('app_config').config[0].defaults
      console.log('notificationLinkTarget' in config)
      if ('notificationLinkTarget' in config) {
        return config.notificationLinkTarget
      }
      return '_self'
    },
    linkPlaceholder(){
    const config = this.configForKey('app_config').config[0]
      if (this.notification.optionalLink && config?.NotificationSettings?.linkText) {
        return config.NotificationSettings.linkText
      }
      return this.notification.optionalLink
    },
  },
  async mounted() {
    await this.loadConfig()
    
  }

}
</script>

<style lang="scss" scoped>
.notification {

  .notification-card {
    height: 100%;
    padding: 1.25rem;
    background: #fafafa; 
    padding: var(--pag-box-padding); 
    border: 1px solid rgba(0,0,0,.125); 
    border-radius: 0.25rem;
    .__card-content {
      display: flex;
      flex-direction: column;
      gap: .5rem;
      justify-content: flex-start;
      align-items: flex-start;
      height: 100%;

      .__notification-type {
        padding: 0.125rem 0.5rem;
        background: #eceef2;
        border-radius: 0.8rem;
        color: #5b6d8b;
      }
      .__notification-date {
      }
      .__notification-title {
        font-weight: 700;
        font-size: 1rem;
      }
      .__notification-description {
          display: block;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;
      }
      .__notification-link {
        cursor: pointer;
      }
      .__notification-link {
        word-break: break-word;
      }
    }
  }


}

</style>